document.addEventListener("DOMContentLoaded", function () {  
  const coffeeId = 44437172420790;
  const lunchId  = 44437174321334;

  const coffeeToggle = document.querySelector('.sb-tip-checkbox[data-feedback="coffee"]');
  const lunchToggle  = document.querySelector('.sb-tip-checkbox[data-feedback="lunch"]');

  const coffeeMsg = "You're a star! Thanks for the love. 🌟";
  const lunchMsg  = "Eek, thank you so much. This is mega! 🌟";


  /* Sync toggle status */
  function syncToggles() {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const coffeeInCart = cart.items.some(item => item.id === coffeeId);
        const lunchInCart  = cart.items.some(item => item.id === lunchId);

        if (coffeeToggle) {
          coffeeToggle.checked = coffeeInCart;
          coffeeInCart ? showFeedback("coffee") : hideFeedback("coffee");
        }

        if (lunchToggle) {
          lunchToggle.checked = lunchInCart;
          lunchInCart ? showFeedback("lunch") : hideFeedback("lunch");
        }
      });
  }

  syncToggles();


  /* Add / Remove items */
  function addItem(variantId, type) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(() => {
      showFeedback(type);
      syncToggles();
      location.reload();
    });
  }

  function removeItem(variantId, type) {
    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        const index = cart.items.findIndex(item => item.id === variantId);

        if (index === -1) {
          hideFeedback(type);
          syncToggles();
          location.reload();
          return;
        }

        const line = index + 1;

        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line, quantity: 0 })
        }).then(() => {
          hideFeedback(type);
          syncToggles();
          location.reload();
        });
      });
  }


  /* Toggle events */
  if (coffeeToggle) {
    coffeeToggle.addEventListener("change", function () {
      this.checked ? addItem(coffeeId, "coffee") : removeItem(coffeeId, "coffee");
    });
  }

  if (lunchToggle) {
    lunchToggle.addEventListener("change", function () {
      this.checked ? addItem(lunchId, "lunch") : removeItem(lunchId, "lunch");
    });
  }


  /* Feedback display */
  function showFeedback(type) {
    const el = document.querySelector(`.sb-feedback-${type}`);
    if (!el) return;
    el.textContent = type === "coffee" ? coffeeMsg : lunchMsg;
    el.style.display = "block";
  }

  function hideFeedback(type) {
    const el = document.querySelector(`.sb-feedback-${type}`);
    if (el) el.style.display = "none";
  }


  /* Info Reveal */
  const infoBtn = document.querySelector(".sb-info-btn");
  const infoText = document.querySelector(".sb-info-text");

  if (infoBtn) {
    infoBtn.addEventListener("click", () => {
      infoText.style.display =
        infoText.style.display === "block" ? "none" : "block";
    });
  }


  /* PubSub Refresh Support (Safe) */
  if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      syncToggles();
    });
  }

});
